import {
  commons,
  specialChild,
  termoMAI,
  others,
  concessionLetterRequired,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

export const MAIDocs = () => {
  const rules = {
    anexoOutros: dynamicRule(),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoLaudoMedico: dynamicRule('required'),
    anexoCarta: dynamicRule('required'),
    anexoTermoMAI: dynamicRule(),
  };

  const docs = {
    commons: [
      ...commons,
      ...specialChild,
      ...concessionLetterRequired,
      ...termoMAI,
      ...others,
    ],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
